<template>
  <v-container fluid grid-list-sm px-1 pb-1 pt-1>
    <v-layout row wrap v-for="(items, i) in banners" :key="i">
      
      <v-flex 
        v-for="banner in items" 
        :key="banner.id" 
        :style="styleFlex(items.length)" 
        @click="goToLink(banner)"
        class="j-banner"
      >
        <img :src="banner.image" alt="lorem" width="100%" height="100%">
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    banners: []
  }),
  methods: {
    ...mapActions("links", ["fetchLinks"]),
    async getBanners() {
      let view_as = localStorage.getItem("view_as")
      const res = await this.fetchLinks(view_as)
      this.banners = res.links_mobile
    },
    styleFlex(length) {
      const width = 100 / length
      return `width: ${width}%;`
    },
    goToLink(banner) {
      if (banner.is_blank == true) window.open(banner.url, "_blank");
      else window.open(banner.url, "_self");
    },
  },
  created() {
    this.getBanners()
  },
}
</script>
<style lang="css" scoped>
.j-banner {
  height: auto;
  padding: 0.5px 0.5px !important;
  cursor: pointer;
}
</style>